import { styled } from 'styled-components';
import { Table, TableColumnsType } from 'antd';
import { FC } from 'react';
import { ITableLike4Like, reportsSelect } from '@entities/reports';
import { useSelector } from 'react-redux';
import { isNotEmptyArray } from '@utils/functions';
import { flexMixin, textMixin } from '@styles/mixins';
import { colors } from '@styles';
import { PuffLoader } from 'react-spinners';
import { cssOverride } from '@utils/const';
import { DiffRevenueInfo } from './ui/DiffRevenueInfo';
import { createLike4LekeColumns } from './ui/columnLike4Like';
import { formatNumberWithDot } from '@utils/functions/formatNumberWithDot';

const TableLike4Like: FC = () => {
    const columns: TableColumnsType<ITableLike4Like> = createLike4LekeColumns();

    const { like4like, loading } = useSelector(reportsSelect);

    if (!isNotEmptyArray(like4like?.table)) {
        return <PuffLoader color={colors.loader} cssOverride={cssOverride} />;
    }

    const summary = () => {
        const totals: ITableLike4Like | undefined = like4like?.total;

        if (!totals) {
            return null;
        }

        return (
            <Table.Summary.Row>
                <Table.Summary.Cell index={0}>
                    <strong>Итого</strong>
                </Table.Summary.Cell>
                <Table.Summary.Cell key="Продажи" index={1}>
                    <StyledSum>
                        {formatNumberWithDot(totals['Продажи'])}
                    </StyledSum>
                </Table.Summary.Cell>

                <Table.Summary.Cell key="Кол-во чеков" index={1}>
                    <StyledSum>{`${totals['Кол-во чеков']} шт`}</StyledSum>
                </Table.Summary.Cell>

                <Table.Summary.Cell key="Средний чек" index={1}>
                    <StyledSum>
                        {formatNumberWithDot(totals['Средний чек'])}
                    </StyledSum>
                </Table.Summary.Cell>
                <Table.Summary.Cell key="Динамика" index={1}>
                    <DiffWrapper>
                        <DiffRevenueInfo diff={totals['Динамика']} />
                    </DiffWrapper>
                </Table.Summary.Cell>
            </Table.Summary.Row>
        );
    };

    return (
        <StyledTable>
            <Table
                pagination={false}
                scroll={{ x: 700 }}
                dataSource={like4like?.table}
                loading={loading === 'loading'}
                columns={columns}
                summary={summary}
                size="small"
            />
        </StyledTable>
    );
};

export default TableLike4Like;

const StyledTable = styled.div`
    .ant-table-thead > tr > th {
        background-color: ${colors.tableHeadBg};
        ${textMixin({
            fontSize: '14px',
            fontWeight: 600,
        })};
        line-height: 16.8px;
        text-align: left;
        height: 45px;
        padding-right: 1.1em !important;
    }

    .ant-table-footer {
        background-color: ${colors.tableHeadBg};
        ${textMixin({
            fontSize: '14px',
            fontWeight: 600,
        })};
        line-height: 16.8px;
        text-align: left;
        border-radius: 4px !important;
    }

    table > tbody > tr > td {
        background-color: ${colors.cleanWhite};
        border: 1px solid #efefef;
        color: ${colors.grey};
        ${textMixin({
            fontSize: '14px',
            fontWeight: 400,
        })};
        line-height: 16.8px;
        text-align: left;
        height: 30px;
    }

    .ant-table-summary {
        background-color: ${colors.tableHeadBg};
        ${textMixin({
            fontSize: '14px',
            fontWeight: 600,
        })};
        line-height: 16.8px;
        text-align: left;
        height: 45px;
        tr > td:first-child {
            border-bottom-left-radius: 8px;
        }

        tr > td:last-child {
            border-bottom-right-radius: 8px;
        }
    }
`;
const StyledSum = styled.div`
    text-align: right;
    padding-right: 0.5em;
`;
const DiffWrapper = styled.div`
    width: 100%;
    ${flexMixin('row', 'flex-end', 'center')};
    padding-right: 0.5em;
`;
